import { IconButton, PlainTooltip, SystemIcon } from '@wishket/design-system';

import { useGetIsScrappedByArticleId } from '@/entities/article';

interface TooltipButtonProps {
  isScrapped: boolean;
  onClick: () => void;
}

export const ScrapTooltipButton = ({
  isScrapped,
  onClick,
}: TooltipButtonProps) => {
  return (
    <PlainTooltip text={isScrapped ? '스크랩됨' : '스크랩'}>
      <IconButton size="md" onClick={onClick}>
        <SystemIcon name="medium_scrap" solid={isScrapped} />
      </IconButton>
    </PlainTooltip>
  );
};

interface UpdatableScrapButtonProps {
  id: number;
  initialIsScrapped: boolean;
  onClick: () => void;
}

export const UpdatableScrapButton = ({
  id,
  initialIsScrapped,
  onClick,
}: UpdatableScrapButtonProps) => {
  const isScrapped = useGetIsScrappedByArticleId(id);

  return (
    <ScrapTooltipButton
      isScrapped={isScrapped ?? initialIsScrapped}
      onClick={onClick}
    />
  );
};
